export default "__VITE_ASSET__BxyLSKLz__"